import { useSavedChartsStore } from '@/stores/savedChartsStore';
import { isValidChartStyleRecid } from '@/composables/isValidChartStyleRecid';

export function hasDefaultChartStyleBeenInitialized() {
  const savedChartsStore = useSavedChartsStore();

  return isValidChartStyleRecid(savedChartsStore.recidOfDefaultChartStyle, false);
}
